var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayCircle = function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "play-circle_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#play-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.996 12.805 3.63-2.332a.53.53 0 0 0 .267-.472q0-.302-.267-.474l-3.63-2.331a.51.51 0 0 0-.576-.031.54.54 0 0 0-.294.503v4.664q0 .342.294.503a.51.51 0 0 0 .576-.03m1.006 5.112a7.7 7.7 0 0 1-3.088-.623A8 8 0 0 1 4.4 15.602a8 8 0 0 1-1.692-2.514 7.7 7.7 0 0 1-.624-3.086q0-1.643.623-3.088A8 8 0 0 1 4.4 4.4a8 8 0 0 1 2.513-1.693A7.7 7.7 0 0 1 10 2.084q1.642 0 3.088.623 1.444.623 2.514 1.692a8 8 0 0 1 1.693 2.513q.623 1.444.623 3.087a7.7 7.7 0 0 1-.623 3.087 8 8 0 0 1-1.692 2.515 8 8 0 0 1-2.513 1.692 7.7 7.7 0 0 1-3.087.624m-.001-1.25q2.79 0 4.729-1.938 1.937-1.937 1.937-4.729T14.73 5.271Q12.793 3.334 10 3.334q-2.79 0-4.729 1.937-1.937 1.937-1.937 4.73 0 2.79 1.937 4.728t4.73 1.938"
  }))));
};
export default SvgPlayCircle;